export default {
  'APP_COMMERCE_VIEW': 'APP_COMMERCE_VIEW',
  'APP_PRODUCT_IDENTIFIER_UPDATE': 'APP_PRODUCT_IDENTIFIER_UPDATE',
  'APP_PWA_STANDALONE_ACCESS': 'APP_PWA_STANDALONE_ACCESS'
}